import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Tag } from "primereact/tag";
import { Badge } from "primereact/badge";
import config from "../../../../config/config";

export default function ComplianceViewModal({ data, visible, onHide, ...props }) {
    if (!data) return null;

    const getComplianceStatusBadge = () => {
        if (!data?.complianceStatus) return null
        const status = data?.complianceStatus?.toUpperCase();
        let className = "";
        switch (status?.toLowerCase()) {
            case "passed": className = "bg-success"; break;
            case "failed": className = "bg-danger"; break;
            case "warning": className = "bg-warning"; break;
            default: className = "bg-secondary";
        }
        return <span className={`badge ${className} text-white px-3 py-2`} style={{ fontSize: "12px" }}>{status} ({data?.complianceScore} %)</span>;
    };

    return (
        <Dialog
            header={
                <div className="d-flex align-items-center justify-content-between w-100 h-100"
                    style={{ width: "100%", maxWidth: "70vw", overflow: "hidden" }}
                >
                    <div className="d-flex align-items-end gap-2 flex-grow-1 overflow-hidden">
                        <a
                            href={config.imgUrl + data?.filePath}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-decoration-none d-flex align-items-center gap-2 flex-grow-1 overflow-hidden"
                            title={data?.fileName}
                            style={{ minWidth: 0 }} // 🔑 REQUIRED for flex ellipsis
                        >
                            <i
                                className="pi pi-file-pdf p-2 flex-shrink-0"
                                style={{ fontSize: "1.75rem", color: "white" }}
                            ></i>

                            <h2
                                style={{
                                    fontSize: "1.3rem",
                                    fontWeight: "400",
                                    color: "white",
                                    margin: 0,
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    maxWidth: "100%",
                                    lineHeight: "1.3rem",
                                }}
                            >
                                {data?.fileName?.replace(/\.[^/.]+$/, "")}
                            </h2>
                        </a>
                    </div>

                    <div className="d-flex align-items-center gap-3 flex-shrink-0">
                        {props.type === "invoice" && getComplianceStatusBadge()}

                        {props.onDownloadPdf && (
                            <Button
                                icon="pi pi-download"
                                label="Download PDF"
                                className="p-button-sm p-button-primary m-5"
                                onClick={() => props.onDownloadPdf(data)}
                            />
                        )}
                    </div>
                </div>

            }
            visible={visible}
            style={{ width: "75vw", maxWidth: "80vw", backgroundColor: "f0f0f0" }}
            modal
            onHide={onHide}
            breakpoints={{ "960px": "95vw", "768px": "100vw" }}
            className="compliance-modal"
        >
            {data && props?.viewModalTemplate && props?.viewModalTemplate(data)}
        </Dialog>
    );
}